import { createSlice } from '@reduxjs/toolkit';

export const dialog = createSlice({
    name: 'dialog',
    initialState: {
        open: false,
    },
    reducers: {
        openDialog(state) {
            state.open = true;
        },
        closeDialog(state) {
            state.open = false;
        }
    }
});

export const { openDialog, closeDialog } = dialog.actions

export default dialog.reducer;